"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var defaultsDeep_1 = tslib_1.__importDefault(require("lodash/defaultsDeep"));
var app_1 = require("./app");
var utils_1 = require("../utils");
var GLOBAL = typeof window !== 'undefined' ? window : global;
var prepOptions = function (userOptions) {
    var options = defaultsDeep_1.default(userOptions, app_1.getOptions());
    if (options.bodyIsFormData) {
        delete options.headers['Content-Type'];
    }
    if (GLOBAL.BIW_CLIENT_FETCH_SESSION_ID) {
        options.headers['x-session-id'] = GLOBAL.BIW_CLIENT_FETCH_SESSION_ID;
    }
    else {
        delete options.headers['x-session-id'];
    }
    // Only GET and POST requests return data
    var responseBodyExpected = /get|post/.test(options.method.toLowerCase());
    if (!responseBodyExpected) {
        options.headers['Accept'] = '*/*';
    }
    // Check whether to parse the response for JSON
    // const parseResponse = !options.noparse;
    // delete options.noparse;
    // If submitting non-url form data and we're submitting JSON, then stringify it
    if (utils_1.isCSV(options) ||
        options.body && options.headers['Content-Type'] === 'application/json' && typeof (options.body) === 'object') {
        options.body = JSON.stringify(options.body);
    }
    options.url = options.baseURL ? "" + options.baseURL + options.url : options.url;
    return options;
};
exports.setSessionId = function (id) {
    GLOBAL.BIW_CLIENT_FETCH_SESSION_ID = id;
};
exports.default = prepOptions;
//# sourceMappingURL=prep.js.map